(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["v-clipboard"] = factory();
	else
		root["v-clipboard"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2017 - 2018 - Yev Vlasenko
 */
var cssText = "position:fixed;pointer-events:none;z-index:-9999;opacity:0;";
var copyErrorMessage = "Failed to copy value to clipboard. Unknown type.";

var $clipboard = function $clipboard(input) {
  var textarea = document.createElement("textarea");
  var value = void 0;

  if (typeof input !== "string") {
    try {
      value = JSON.stringify(input);
    } catch (e) {
      throw copyErrorMessage;
    }
  } else {
    value = input;
  }

  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.style.cssText = cssText;

  document.body.appendChild(textarea);

  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    var editable = textarea.contentEditable;
    var readOnly = textarea.readOnly;

    textarea.contentEditable = true;
    textarea.readOnly = true;

    var range = document.createRange();

    range.selectNodeContents(textarea);

    var selection = window.getSelection();

    selection.removeAllRanges();
    selection.addRange(range);
    textarea.setSelectionRange(0, 999999);

    textarea.contentEditable = editable;
    textarea.readOnly = readOnly;
  } else {
    textarea.select();
  }

  var success = false;

  try {
    success = document.execCommand("copy");
  } catch (err) {
    console.warn(err);
  }

  document.body.removeChild(textarea);

  return success;
};

exports.default = {
  install: function install(Vue) {
    Vue.prototype.$clipboard = $clipboard;

    var generateId = function (id) {
      return function () {
        return "$" + id++;
      };
    }(1);
    var handlers = {};

    var removeHandler = function removeHandler(id) {
      if (id) {
        handlers[id] = null;
        delete handlers[id];
      }
    };

    var addHandler = function addHandler(func) {
      var id = generateId();
      handlers[id] = func;

      return id;
    };

    Vue.directive("clipboard", {
      bind: function bind(el, binding) {
        var arg = binding.arg,
            value = binding.value;


        switch (arg) {
          case "error":
            var errorHandlerId = addHandler(value);
            el.dataset.clipboardErrorHandler = errorHandlerId;
            return;

          case "success":
            var successHandlerId = addHandler(value);
            el.dataset.clipboardSuccessHandler = successHandlerId;
            return;

          default:
            var clickEventHandler = function clickEventHandler(event) {
              if (binding.hasOwnProperty("value")) {
                var payload = {
                  value: typeof value === "function" ? value() : value,
                  event: event
                };

                var handlerId = $clipboard(payload.value) ? el.dataset.clipboardSuccessHandler : el.dataset.clipboardErrorHandler;

                var handler = handlers[handlerId];

                if (handler) {
                  handler(payload);
                }
              }
            };

            var clickEventHandlerId = addHandler(clickEventHandler);

            el.dataset.clipboardClickHandler = clickEventHandlerId;
            el.addEventListener("click", handlers[clickEventHandlerId]);

            return;
        }
      },
      unbind: function unbind(el) {
        var _el$dataset = el.dataset,
            clipboardSuccessHandler = _el$dataset.clipboardSuccessHandler,
            clipboardErrorHandler = _el$dataset.clipboardErrorHandler,
            clipboardClickHandler = _el$dataset.clipboardClickHandler;


        removeHandler(clipboardSuccessHandler);
        removeHandler(clipboardErrorHandler);

        if (clipboardClickHandler) {
          el.removeEventListener("click", handlers[clipboardClickHandler]);
          removeHandler(clipboardClickHandler);
        }
      }
    });
  }
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.min.js